module.exports = __webpack_public_path__ + "img/banner-two10.814cd9b5.png";